import React from "react";
import Header from "./header";
import Footer from "./footer";

export default function Layout({ lang, setLang, children }) {
  return (
    <div className="layout">
      <Header lang={lang} setLang={setLang} />
      <main className="layout-main">{children}</main>
      <Footer />
    </div>
  );
}